import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLike, meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PartitionOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/partition-operator/geometry-partition-operator-node"
import {
    GeometryPartitionOperatorNode,
    partitionOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/partition-operator/geometry-partition-operator-node"

export type MeshGeometryPartitionOperatorParameters = PartitionOperatorParameters<MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryPartitionOperatorParameters> = {
    nodeClass: "MeshGeometryPartitionOperator",
    validation: {
        parameters: partitionOperatorParametersSchema(meshGeometryAttributeLike, meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryPartitionOperator
    extends GeometryPartitionOperatorNode<2, MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
